'use strict';

const h = require('phy');

module.exports = ({ logoSourceSet }) =>
  h('img#select-widget-logo', {
    alt: 'Groupon Select logo',
    src: logoSourceSet['1x'],
    srcset: `${logoSourceSet['2x']} 2x, ${logoSourceSet['3x']} 3x`,
  });
